<div id="noteSuccessMsg" class="alert alert-success"></div>
<div id="noteErrorMsg" class="alert alert-danger"></div>
<div id="noteAlartMsg" class="alert alert-warning"></div>
<router-outlet></router-outlet>
<a id="back-to-top" title="Back to top" style="display: none;"><i class="fas fa-arrow-up"></i></a>

<!-- Modal -->
<div class="modal fade" id="logoutModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="incubatee-div-modal">
                <div class="mb-2">
                    <img src="assets/images/alarm-clock.gif" class="img" alt="">
                </div>
                <div>
                    <h4>Session Timeout</h4>
                    <p>You weren't clicking around any more, so we logged you out for security reasons. To get back in,
                        just login again</p>
                </div>
                <div class="text-center mt-3">
                    <button mat-raised-button color="warn" (click)="logout()">Logout</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="guidelinesModal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div *ngIf="guidelineDatas.Guidelines!=''">
                <div class="guideline-header">
                    <h4 class="d-flex"><span class="material-icons">description</span> <span
                            class="ml-1">Guidelines</span></h4>
                </div>
                <div class="guideline-content">
                    <ul class="phases-uls">
                        <li *ngFor="let list of guidelineDatas.Guidelines">{{list}}</li>
                    </ul>
                </div>
            </div>
            <div *ngIf="guidelineDatas.evidence!=''">
                <div class="guideline-header">
                    <h4 class="d-flex"><span class="material-icons">description</span> <span
                            class="ml-1">Evidence</span></h4>
                </div>
                <div class="guideline-content">
                    <ul class="phases-uls">
                        <li *ngFor="let list of guidelineDatas.evidence">{{list}}</li>
                    </ul>
                </div>
            </div>
            <div class="text-right m-3">
                <button mat-raised-button (click)="guidelineClose()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="updateModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="incubatee-div-modal">
                <div class="mb-2">
                    <img src="assets/images/storyboard.gif" class="img profile-gif" alt="">
                </div>
                <div>
                    <h4>Is Profile Details and incubatee details are up to date ?</h4>
                    <!-- <p>Is Profile Details and incubatee details are up to date ?</p> -->
                </div>
                <div class="text-center mt-3">
                    
                    <!-- <button mat-raised-button color="primary" class="mr-3" (click)="updateBtn('Update Later')">Update Later</button> -->
                    <button mat-raised-button color="accent" (click)="updateBtn('Update')">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>